export default "__VITE_ASSET__c73e1809__"